import { FacetGroupConfig } from "@made-people/grease-search";
import { getSizeChartByCountryCode } from "../services/centra/mappers/utils/get-sizechart-by-country-code";

export const createMissMaryFacetGroupingFunction =
  (countryCode: string) => (): FacetGroupConfig[] => {
    const activeSizeChart = getSizeChartByCountryCode(countryCode);

    const SIZE_CHART_DELIMITER = "x";

    return [
      {
        id: "sizechart.sizechart_eu.label", // This is the translateable label for the size chart
        name: "sizechart.sizechart_eu.label", // This is the translateable label for the size chart
        facetIds: [
          `sizechart.${activeSizeChart}.type`,
          `sizechart.${activeSizeChart}.cup_type`,
        ],
        relationship: "and",
        compositeField: {
          fieldName: `sizechart.${activeSizeChart}.label`,
          valueFormatter: (bandSize: string, cupType: string) =>
            `${bandSize}${SIZE_CHART_DELIMITER}${cupType}`,
          facetOrder: [
            `sizechart.${activeSizeChart}.type`,
            `sizechart.${activeSizeChart}.cup_type`,
          ],
        },
      },
    ];
  };
